"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var utils_1 = require("../utils");
var ErrorBoundary = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            error: null,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ error: error });
        utils_1.sentryReport(error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, this.state.error ? (react_1.default.createElement("div", { className: "snap" },
            react_1.default.createElement("p", null, "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A."),
            react_1.default.createElement("p", null, "\u041D\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0443\u0436\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043D\u0430\u0434 \u044D\u0442\u0438\u043C."),
            react_1.default.createElement("p", null,
                "\u041F\u043E \u0432\u0441\u0435\u043C \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430 \u0435\u043C\u0435\u0439\u043B:",
                ' ',
                react_1.default.createElement("a", { href: "mailto:info@alakatto.ru" }, "info@alakatto.ru")))) : (this.props.children)));
    };
    return ErrorBoundary;
}(react_1.default.Component));
exports.ErrorBoundary = ErrorBoundary;
